import logo from '../assets/logo.webp'

export default function HeaderImg() {
  return <img src={logo} alt="Sopa de Oliva Logo" className="header-img"/>
  
}